// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsPropertyDetailsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsPropertyDetailsWebApiHandler_details,
  CappsPropertyDetailsWebApiHandler_details_Path,
  CappsPropertyDetailsWebApiHandler_isListingPresent,
  CappsPropertyDetailsWebApiHandler_isListingPresent_Path,
  CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted,
} from '@zg-rentals/ts-capps-client';

import type {
  ListingAlias,
  PropertyDetailsResponseDto,
  UpdateApplicationsAcceptedRequestDto,
} from '@zg-rentals/ts-capps-client';

interface DetailsParams {
  listingAlias: ListingAlias;
}
interface IsListingPresentParams {
  listingAlias: ListingAlias;
}

export type CappsPropertyDetailsWebApiHandler_details_Options = UseQueryOptions<
  PropertyDetailsResponseDto,
  unknown,
  PropertyDetailsResponseDto,
  readonly [string, DetailsParams]
>;

const CappsPropertyDetailsWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [CappsPropertyDetailsWebApiHandler_details_Path, getParams] as const;

export const CappsPropertyDetailsWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsPropertyDetailsWebApiHandler_details_GetKey(getParams),
    queryFn: () => CappsPropertyDetailsWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsPropertyDetailsWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsPropertyDetailsWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...CappsPropertyDetailsWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsPropertyDetailsWebApiHandler_details.getKey = CappsPropertyDetailsWebApiHandler_details_GetKey;

export type CappsPropertyDetailsWebApiHandler_isListingPresent_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, IsListingPresentParams]
>;

const CappsPropertyDetailsWebApiHandler_isListingPresent_GetKey = (getParams: IsListingPresentParams) =>
  [CappsPropertyDetailsWebApiHandler_isListingPresent_Path, getParams] as const;

export const CappsPropertyDetailsWebApiHandler_isListingPresent_queryOptions = (
  getParams: IsListingPresentParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsPropertyDetailsWebApiHandler_isListingPresent_GetKey(getParams),
    queryFn: () => CappsPropertyDetailsWebApiHandler_isListingPresent(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsPropertyDetailsWebApiHandler_isListingPresent = (
  getParams: IsListingPresentParams,
  {
    httpClient,
    ...options
  }: Omit<CappsPropertyDetailsWebApiHandler_isListingPresent_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsPropertyDetailsWebApiHandler_isListingPresent_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsPropertyDetailsWebApiHandler_isListingPresent.getKey =
  CappsPropertyDetailsWebApiHandler_isListingPresent_GetKey;

export interface CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args {
  postData: UpdateApplicationsAcceptedRequestDto;
}

export type CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Options = UseMutationOptions<
  void,
  unknown,
  CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args
>;

export const useCappsPropertyDetailsWebApiHandler_updateApplicationsAccepted = ({
  httpClient,
  ...options
}: Omit<CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Args) =>
      CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted(args.postData, httpClient),
  });
};
